import React, { useState, useEffect, useRef } from "react";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import Button from "../../../common/button";
import StepMap from "./steps/StepMap";
import StepPayment from "./steps/StepPayment";
import StepFinish from "./steps/StepFinish";
import { useNavigate } from "react-router-dom";

const StepWizardCom = () => {
  const [backButton, setBackButton] = useState(true);
  const [nextButton, setNextButton] = useState(true);
  const [finishButton, setFinishButton] = useState(true);
  const [successPayment, setSuccessPayment] = useState(false);
  const [selectLand, setSelectLand] = useState([]);
  const [closeUnity, setCloseUnity] = useState(false);
  const [payment, setPayment] = useState("CREDITCARD");

  const nextButtonRef = useRef();

  const navigate = useNavigate();

  useEffect(() => {
    if (successPayment) {
      nextButtonRef.current.click();
    }
  }, [successPayment]);

  const handleComplete = () => {
    console.log("Form completed!");
    // Handle form completion logic here
  };

  const backTemplate = (handlePrevious) => {
    return (
      <div>
        {backButton ? (
          <Button
            variant={"blue"}
            className="mt-4 p-2"
            onClick={handlePrevious}
          >
            back
          </Button>
        ) : null}
      </div>
    );
  };

  // const nextTemplate = (handleNext) => {
  //   return (
  //     <div style={nextButton ? null : { visibility: "hidden", width: "0.1px" }}>
  //       <Button ref={nextButtonRef} variant={"blue"} onClick={handleNext}>
  //         next
  //       </Button>
  //     </div>
  //   );
  // };

  const nextTemplate = (handleNext) => {
    const handleClick = () => {
      setCloseUnity(true);

      setTimeout(() => {
        handleNext();
      }, 1000);
    };

    return (
      <>
        <div style={{ visibility: "hidden", width: 0 }}>
          <button
            ref={nextButtonRef}
            className={"base-button"}
            onClick={handleNext}
          >
            next
          </button>
        </div>

        {nextButton && selectLand.length > 0 ? (
          <div className="mb-5">
            <Button
              // ref={nextButtonRef}
              variant={"blue"}
              className="mt-4 p-2"
              onClick={handleClick}
            >
              next
            </Button>
          </div>
        ) : (
          <>
            {selectLand.length === 0 ? (
              <>
                <div className="mb-5">
                  <Button
                    variant={"mint-disabled"}
                    className="mt-4 p-2"
                    style={{ cursor: "not-allowed" }}
                  >
                    next
                  </Button>
                </div>
              </>
            ) : null}
          </>
        )}
      </>
    );
  };

  const finishTemplate = () => {
    return (
      <>
        {finishButton ? (
          <button className="finish-button" onClick={() => navigate("/")}>
            finish
          </button>
        ) : null}
      </>
    );
  };

  function MapIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20"
        width="20"
        viewBox="0 0 512 512"
      >
        <path
          fill="#ffffff"
          d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
        />
      </svg>
    );
  }

  function PaymentIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20"
        width="20"
        viewBox="0 0 512 512"
      >
        <path
          fill="#ffffff"
          d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        />
      </svg>
    );
  }

  function CheckIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20"
        width="17.5"
        viewBox="0 0 448 512"
      >
        <path
          fill="#ffffff"
          d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
        />
      </svg>
    );
  }

  return (
    <>
      <FormWizard
        onComplete={handleComplete}
        backButtonTemplate={backTemplate}
        nextButtonTemplate={nextTemplate}
        finishButtonTemplate={finishTemplate}
        color="#5865f2"
        stepSize="sm"
      >
        <FormWizard.TabContent
          title="MAP"
          icon={MapIcon()}
          style={{ height: "100%" }}
        >
          <StepMap
            setNextButton={setNextButton}
            setSelectLand={setSelectLand}
            closeUnity={closeUnity}
          />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="PAYMENT" icon={PaymentIcon()}>
          <StepPayment
            setSuccessPayment={setSuccessPayment}
            setNextButton={setNextButton}
            selectLand={selectLand}
            setPayment={setPayment}
          />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="LAST STEP" icon={CheckIcon()}>
          <StepFinish
          setSuccessPayment={setSuccessPayment}
            setBackButton={setBackButton}
            setFinishButton={setFinishButton}
            selectLand={selectLand}
            payment={payment}
          />
        </FormWizard.TabContent>
      </FormWizard>
      {/* add style */}
      <style>{`
        @import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
        .wizard-card-footer{
          display: flex;
          justify-content: center;
     
        }

        .stepTitle {
          font-family: "Bakbak One";

        }

        .react-form-wizard .wizard-icon-circle {
          background-color:#5865f2
        }

        .base-button {
          background-color: blue;
          border: none;
          color: white;
          padding: 15px 32px;
          text-align: center;
          text-decoration: none;
          display: inline-block;
          font-size: 16px;
          cursor: pointer;
          margin-right: 10px;
          margin-left: 10px;
          border-radius: 50px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
          transition: background-color 0.3s ease;
          }
          
          .base-button:hover {
          background-color: navy;
          }
          
          .base-button:focus {
          outline: none;
          }
          
          .base-button:active {
          transform: translateY(2px);
          }

        .finish-button{
          background-color: red;
          border: none;
          color: white;
          padding: 15px 32px;
          text-align: center;
          text-decoration: none;
          display: inline-block;
          font-size: 16px;
          cursor: pointer;
          margin-right: 10px;
          margin-left: 10px;
          border-radius: 50px;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
          transition: background-color 0.3s ease;
        }
        .finish-button:hover {
          background-color: darkgreen;
          }
        
        .finish-button:focus {
          outline: none;
         }
          
        .finish-button:active {
          transform: translateY(2px);
         }
      `}</style>
    </>
  );
};

export default StepWizardCom;
